import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "company-dashboard grid grid-cols-1 xl:grid-cols-2" }
const _hoisted_2 = { class: "bg-company-gradient-t-b text-white p-9 flex flex-col border-b xl:border-b-0 xl:border-r border-pink-1" }
const _hoisted_3 = { class: "flex justify-center" }
const _hoisted_4 = { class: "xl:flex items-start lg:pl-16 lg:pr-16 flex-col" }
const _hoisted_5 = { class: "flex-1 mt-8 mb-4 text-display-xs" }
const _hoisted_6 = { class: "flex flex-col min-h-full" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }

import { AttachmentKey } from "@/api/models/types";
import CompanyLogo from "@/components/CompanyLogo.vue";
import MatchdButton from "@/components/MatchdButton.vue";
import ProfileSection from "@/components/ProfileSection.vue";
import CompanyMatchGroup from "@/components/dashboard/CompanyMatchGroup.vue";
import PostingEditLink from "@/components/dashboard/PostingEditLink.vue";
import useProgressIndicator from "@/helpers/useProgressIndicator";
import type { CompanyDashboard as ICompanyDashboard } from "@/models/CompanyDashboard";
import { Routes } from "@/router";
import { useStore } from "@/store";
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import ChallengeTypeMentoringButton from "../ChallengeTypeMentoringButton.vue";
import DeletionInfoModal from "./DeletionInfoModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyDashboard',
  props: {
    dashboard: {}
  },
  setup(__props: any) {


const store = useStore();
const route = useRoute();
const user = computed(() => store.getters["user"]);
const showDeletionInfoModal = ref(false);
const { progress, formatProgress } = useProgressIndicator();

const avatar = computed(
  () =>
    store.getters["attachmentsByKey"]({
      key: AttachmentKey.CompanyAvatar,
    })?.[0] ||
    store.getters["attachmentsByKey"]({
      key: AttachmentKey.CompanyAvatarFallback,
    })?.[0] ||
    undefined,
);

onMounted(() => {
  if ("challengeDeleted" in route.query || "jobPostingDeleted" in route.query) {
    showDeletionInfoModal.value = true;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (avatar.value && user.value?.company?.name)
          ? (_openBlock(), _createBlock(CompanyLogo, {
              key: 0,
              url: avatar.value.url,
              name: user.value?.company?.name,
              class: "m-5 lg:m-20 w-40 h-40 xl:w-60 xl:h-60"
            }, null, 8, ["url", "name"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "flex-1 mb-4 text-display-xs" }, " Willkommen zurück bei Matchd! Wir wünschen viel Erfolg bei der Talentsuche ", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("p", null, " Auf dieser Seite finden Sie Ihre ausgeschriebenen Challenges | Mentorings und Stellen sowie den aktuellen Stand Ihrer Matches. Damit Sie keinen Match verpassen, informieren wir Sie jeweils auch per E-Mail. ", -1)),
        (_unref(progress) && _unref(progress).global < 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("h2", _hoisted_5, " Ihr Profil ist zu " + _toDisplayString(_unref(formatProgress)(_unref(progress).global)) + " vollständig. ", 1),
              _cache[2] || (_cache[2] = _createElementVNode("p", { class: "mb-8" }, " Damit Talents Sie besser finden und sich mit Ihnen verbinden können, sollten Sie zuerst Ihr Profil vervollständigen. ", -1)),
              _createVNode(MatchdButton, {
                tag: "router-link",
                to: { name: _unref(Routes).PROFILE_EDIT, params: { step: 'schritt1' } }
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode(" Profil vervollständigen ", -1)
                ]))]),
                _: 1
              }, 8, ["to"])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(ProfileSection, {
        title: "Ihre Ausschreibungen",
        pink: true
      }, {
        default: _withCtx(() => [
          _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "text-base font-medium text-primary-1 mb-4" }, "Challenges | Mentorings", -1)),
          (__props.dashboard?.challenges?.length === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Momentan haben Sie noch keine Challenges | Mentorings ausgeschrieben. Sobald Sie ein/e Challenge | Mentoring ausschreiben, kann die Talentsuche beginnen. "))
            : _createCommentVNode("", true),
          (__props.dashboard?.challenges?.length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dashboard?.challenges, (challenge) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: challenge.id,
                    class: "link-list__item"
                  }, [
                    _createVNode(PostingEditLink, { posting: challenge }, null, 8, ["posting"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createVNode(MatchdButton, {
            class: "block w-full mt-8 text-center",
            to: { name: _unref(Routes).CHALLENGE_CREATE },
            tag: "router-link"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode(" Challenge | Mentoring ausschreiben ", -1)
            ]))]),
            _: 1
          }, 8, ["to"]),
          _createVNode(ChallengeTypeMentoringButton),
          _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "text-base font-medium text-primary-1 mt-12 mb-4" }, "Stellen", -1)),
          (__props.dashboard?.jobPostings?.length === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Momentan haben Sie noch keine Stelle ausgeschrieben. Sobald Sie eine Stelle ausschreiben, kann die Talentsuche beginnen. "))
            : _createCommentVNode("", true),
          (__props.dashboard?.jobPostings?.length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dashboard?.jobPostings, (jobPosting) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: jobPosting.id,
                    class: "link-list__item"
                  }, [
                    _createVNode(PostingEditLink, { posting: jobPosting }, null, 8, ["posting"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createVNode(MatchdButton, {
            class: "block w-full mt-8 text-center",
            to: { name: _unref(Routes).JOB_POSTING_CREATE },
            tag: "router-link"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" Neue Stelle ausschreiben ", -1)
            ]))]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }),
      _createVNode(ProfileSection, {
        title: "Ihre offenen Matches",
        pink: true
      }, {
        default: _withCtx(() => [
          (__props.dashboard?.requestedMatches?.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, " Sobald Ihre Matching-Anfrage vom Talent bestätigt wurde, kanns mit dem Kennenlernen weitergehen. "))
            : (_openBlock(), _createElementBlock("p", _hoisted_12, " Momentan haben Sie keine offenen Matches. Sobald Sie ein Match auslösen, werden Sie das hier sehen. ")),
          (__props.dashboard?.uniqueRequestedJobPostingMatchings?.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "text-base font-medium text-primary-1 mb-4 mt-8" }, "Stellen", -1)),
                _createVNode(CompanyMatchGroup, {
                  class: "mt-4",
                  matches: __props.dashboard?.uniqueRequestedJobPostingMatchings
                }, null, 8, ["matches"])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(ProfileSection, {
        title: "Anfragen zum Matching",
        pink: true
      }, {
        default: _withCtx(() => [
          (!__props.dashboard?.uniqueUnconfirmedJobPostingMatchings?.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_13, " Momentan haben Sie keine offenen Anfragen. Sobald ein Talent ein Match auslöst, werden Sie das hier sehen. "))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _cache[11] || (_cache[11] = _createElementVNode("p", null, "Ihre Ausschreibung ist beliebt. Folgende Talente möchten Sie gerne kennenlernen.", -1)),
                (__props.dashboard?.uniqueUnconfirmedJobPostingMatchings?.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "text-base font-medium text-primary-1 mb-4 mt-8" }, "Stellen", -1)),
                      _createVNode(CompanyMatchGroup, {
                        class: "mt-4",
                        matches: __props.dashboard?.uniqueUnconfirmedJobPostingMatchings
                      }, null, 8, ["matches"])
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
        ]),
        _: 1
      }),
      (
          __props.dashboard?.confirmedMatches?.length ||
          __props.dashboard?.uniqueChallengeMatchingsWithStudents?.length
        )
        ? (_openBlock(), _createBlock(ProfileSection, {
            key: 0,
            title: "Hier hats gematchd!",
            pink: true
          }, {
            default: _withCtx(() => [
              (__props.dashboard?.uniqueChallengeMatchingsWithStudents?.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "text-base font-medium text-primary-1 mb-4" }, "Challenges | Mentorings", -1)),
                    _createVNode(CompanyMatchGroup, {
                      matches: __props.dashboard?.uniqueChallengeMatchingsWithStudents
                    }, null, 8, ["matches"])
                  ], 64))
                : _createCommentVNode("", true),
              (__props.dashboard?.uniqueJobPostingMatchings?.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "text-base font-medium text-primary-1 mb-4 pt-8" }, "Stellen", -1)),
                    _createVNode(CompanyMatchGroup, {
                      matches: __props.dashboard?.uniqueJobPostingMatchings
                    }, null, 8, ["matches"])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(DeletionInfoModal, {
      "show-modal": showDeletionInfoModal.value,
      "onUpdate:showModal": _cache[0] || (_cache[0] = ($event: any) => ((showDeletionInfoModal).value = $event))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString("challengeDeleted" in _unref(route).query
          ? "Challenge | Mentoring gelöscht"
          : "jobPostingDeleted" in _unref(route).query
            ? "Stelle gelöscht"
            : ""), 1)
      ]),
      default: _withCtx(() => [
        _createTextVNode(" " + _toDisplayString("challengeDeleted" in _unref(route).query
          ? "Die Challenge | Mentoring wurde erfolgreich gelöscht."
          : "jobPostingDeleted" in _unref(route).query
            ? "Die Stelle wurde erfolgreich gelöscht."
            : ""), 1)
      ]),
      _: 1
    }, 8, ["show-modal"])
  ]))
}
}

})